import { atom } from 'recoil';

export const classPlaylistContent = atom({
  key: 'classPlaylistContent',
  default: '',
});
